import client from './client';

export const activityApi = {
  getAll: (params) => client.get('/activity', { params }),
  getStats: (params) => client.get('/activity/stats', { params }),
  getAdminsWithActivity: () => client.get('/activity/admins'),
  getByAdmin: (adminId, params) => client.get(`/activity/admin/${adminId}`, { params }),
  getAdminStats: (adminId) => client.get(`/activity/admin/${adminId}/stats`),
  getMyActivity: (params) => client.get('/activity/me', { params }),
  trackPageVisit: (page) => client.post('/activity/track', { page })
};
